import { Component, HostBinding, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ToasterMessages } from 'src/app/shared/constants/constants';
import { getmonths } from 'src/app/shared/helpers/Drop-down-options';
import { CargoheatingCommonService } from 'src/app/shared/service/cargo-heating-service/cargoheating-common.service';
import { RequestFormService } from 'src/app/shared/service/requestForm/request-form.service';

@Component({
  selector: 'app-c-home',
  templateUrl: './c-home.component.html',
  styleUrls: ['./c-home.component.scss']
})
export class CHomeComponent {
  @HostBinding('class.ch-light') get chLight(): boolean {
    return !this.isDarkMode();
  }
dashboardForm: FormGroup;
  monthOptions: string[];

  formSubmitted: boolean = false;
  vesselSuggestions: any[] = [];
  elements: any[] = [];
  snackBar: any;

  // Modern Filter State
  vesselSearchQuery: string = '';
  monthSearchQuery: string = '';
  vesselDropdownOpen = false;
  monthDropdownOpen = false;
  vesselOptions: string[] = [];
  showWeeklyUpdatesModal = false;
  isVesselLoading = false;
  constructor(
    private fb: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private commonService: CargoheatingCommonService,
        private requestFormService: RequestFormService,
  ) {
    this.dashboardForm = this.fb.group({
     // shipname: ['', Validators.required],
      vesselname: ['', ],
      month: ['', Validators.required],
      shipImo: [''],

    });
    this.monthOptions = getmonths();
    this.getVesselData();
    this.dashboardForm.get('shipImo')?.valueChanges.subscribe((imoValue) => {
      this.onImoChange(imoValue);
    });

    // Subscribe to vessel name changes
    this.dashboardForm.get('vesselname')?.valueChanges.subscribe((vesselName) => {
      this.onVesselNameChange(vesselName);
    });
  }
  ngOnInit(): void {

      this.snackBar.open(ToasterMessages.InvalidMessage, 'Close', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'top',
      });
  }
  onVesselNameChange(vesselName: string) {
    if (vesselName) {
      const selectedVessel = this.elements.find(v => v.vessel_name.toLowerCase() === vesselName.toLowerCase());
      if (selectedVessel) {
        this.dashboardForm.get('shipImo')?.setValue(selectedVessel.vessel_imo, { emitEvent: false });
      }
    }
  }

  // Triggered when vessel IMO changes
  onImoChange(imoValue: string) {
    if (imoValue) {
      const selectedVessel = this.elements.find(v => v.vessel_imo === imoValue);
      if (selectedVessel) {
        this.dashboardForm.get('vesselname')?.setValue(selectedVessel.vessel_name, { emitEvent: false });
      }
    }
  }

  // fetchClick() {
  //   this.formSubmitted = true;
  //   localStorage.setItem('vesselImo',  this.dashboardForm.get('shipImo')?.value);
  //   localStorage.setItem('month', this.dashboardForm.get('month')?.value);
  //   localStorage.setItem('vesselName', this.dashboardForm.get('vesselname')?.value);
  //   if( this.dashboardForm.valid){
  //     const imo = this.dashboardForm.get('shipImo')?.value;
  //     const shipName = this.dashboardForm.get('vesselname')?.value;
  //     if(imo || shipName){
  //       this.router.navigate(['/analyticsDashboard']);
  //     }else{
  //       this.toastr.info(ToasterMessages.FormValidationLength);
  //     }
      
  //   }else{
  //     this.toastr.info(ToasterMessages.FormValidation);
  //   }

  // }

  
  fetchClick() {
    this.formSubmitted = true;

    localStorage.setItem('vesselImo', this.dashboardForm.get('shipImo')?.value);
    localStorage.setItem('month', this.dashboardForm.get('month')?.value);
    localStorage.setItem('vesselName', this.dashboardForm.get('vesselname')?.value);
  
   
    if (this.dashboardForm.valid) {
      const imo = this.dashboardForm.get('shipImo')?.value;
      const shipName = this.dashboardForm.get('vesselname')?.value;
  
     
      if (imo || shipName) {
        
        let payload = {
          vessel_imo: localStorage.getItem('vesselImo'),
          month: localStorage.getItem('month'),
          vessel_name: localStorage.getItem('vesselName')
        };
       
        this.commonService.getGraphData(payload).subscribe(
          (data: any) => {
            console.log('API Response err:', data); 
  
          
            if (data && data.length > 0) {
          
              this.router.navigate(['/ch-analyticsDashboard']);
            } else {
             
              this.toastr.warning(ToasterMessages.DataNotFount);
            }
          },
          (error) => {
            console.error('API Error:', error); 
          
            this.toastr.warning(ToasterMessages.DataNotFount);
          }
        );
      } else {
        this.toastr.info(ToasterMessages.FormValidationLength);
      }
    } else {
      this.toastr.info(ToasterMessages.FormValidation);
    }
  }
  
  isDarkMode() {
    return this.requestFormService.isDarkMode();
  }

  openWeeklyUpdatesModal(): void {
    this.showWeeklyUpdatesModal = true;
  }

  closeWeeklyUpdatesModal(): void {
    this.showWeeklyUpdatesModal = false;
  }

  // Modern Dropdown Toggles
  toggleVesselDropdown(event?: Event) {
    if (event) event.stopPropagation();
    this.vesselDropdownOpen = !this.vesselDropdownOpen;
    this.monthDropdownOpen = false;
  }

  toggleMonthDropdown(event?: Event) {
    if (event) event.stopPropagation();
    this.monthDropdownOpen = !this.monthDropdownOpen;
    this.vesselDropdownOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    this.vesselDropdownOpen = false;
    this.monthDropdownOpen = false;
  }

  getFilteredVessels() {
    return this.vesselOptions.filter(opt => opt.toLowerCase().includes(this.vesselSearchQuery.toLowerCase()));
  }

  getFilteredMonths() {
    return this.monthOptions.filter((opt: any) => opt.toLowerCase().includes(this.monthSearchQuery.toLowerCase()));
  }

  onVesselSelect(vesselName: string) {
    this.dashboardForm.get('vesselname')?.setValue(vesselName);
    this.vesselDropdownOpen = false;
  }

  onMonthSelect(month: string) {
    this.dashboardForm.get('month')?.setValue(month);
    this.monthDropdownOpen = false;
  }

  getVesselData(){
    this.isVesselLoading = true;
    this.commonService.getVesselData().subscribe({
      next: (data)=>{
        this.elements  = data;
        this.vesselOptions = Array.from(new Set(data.map((d: any) => d.vessel_name).filter(Boolean))).sort() as string[];
        this.isVesselLoading = false;
      },
      error:()=>{
        this.isVesselLoading = false;
      }
    })
  }

  filterVesselNames(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    console.log("inputValue",inputValue)
    if (inputValue.length > 0) {
      this.vesselSuggestions = this.elements.filter((item:any) =>
        item.vessel_name.toLowerCase().includes(inputValue)
      );
      console.log("vesselSuggestions",this.vesselSuggestions)
    } else {
      this.vesselSuggestions = [];
    }
  }
  clearFilters() {
    this.dashboardForm.reset();
    this.vesselSearchQuery = '';
    this.monthSearchQuery = '';
    this.getVesselData();
  }
}
